import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const styles = tv({
	slots: {
		base: 'grid grid-cols-4 lg:grid-cols-6 bg-mainPink px-2 py-5 lg:px-4 lg:py-6 gap-x-2 lg:gap-x-4 gap-y-1 lg:gap-y-0 items-end',
		heading: '!col-span-4 lg:!col-span-3',
		content: 'flex flex-col space-y-2 col-span-4 lg:col-span-3 max-w-[50rem] lg:justify-self-end',
	},
})

export type StylesVariants = VariantProps<typeof styles>
